import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
import { TextInput } from "../text-input";
/**
 * @typedef {import("../text-input/TextInput").TextInputProps &
 *  { ref: import("react").Ref<HTMLInputElement> } &
 *  { [key: string]: any }
 * } SearchInputProps
 */

/**
 * @type {React.FC<SearchInputProps>}
 */

export const SearchInput = /*#__PURE__*/React.forwardRef(function SearchInput(props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: "ml-2 relative "
  }, /*#__PURE__*/React.createElement("span", {
    className: "fas fa-search text-gray-700 m-auto absolute left-3 top-0  bottom-0"
  }), /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    type: "search",
    ref: ref,
    Input: Input
  })));
});
SearchInput.propTypes = TextInput.propTypes; // ==== begin dependencies

const Input = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {*} props
 * @param {import("react").MutableRefObject<HTMLInputElement>} ref
 * @returns
 */
function Input({
  className,
  ...props
}, ref) {
  return /*#__PURE__*/React.createElement("input", _extends({}, props, {
    ref: ref,
    className: classNames(className, {
      border: false,
      "p-2": false,
      "rounded-md": false
    }, "border-2 rounded pl-8 pr-1 py-2")
  }));
});
Input.propTypes = {
  className: PropTypes.any
};